var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("QuantityCheck", {
        attrs: {
          maintenanceId: _vm.maintenanceId,
          normalTemperatureItems: _vm.normalTemperatureItems,
          refrigeratedItems: _vm.refrigeratedItems,
          checkList: _vm.checkList,
          type: "loss"
        },
        on: {
          changeCheckbox: _vm.changeCheckbox,
          finish: _vm.finish,
          back: _vm.back
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f126db6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f126db6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/LossCheck.vue
// module id = null
// module chunks = 